import { createSelector } from 'reselect';

import type { State } from 'reducers';

import { initialState } from './reducer';
import type { VolunteerFormPageState } from './reducer';

const selectState = (state: State): VolunteerFormPageState =>
  state.get('VolunteerFormPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
